import React from "react";
import { ReactComponent as WardrobeSvg } from "../svg/wardrobe.svg";

export default function WardrobeIcon({ size = 64, color = "#32363F", ...props }) {
  return <WardrobeSvg width={size} height={size} style={{ color }} {...props} />;
}
